<div class="extensions-menu"
  role="menu"
  aria-orientation="vertical">
  <div *ngFor="let item of menuItems"
    class="menu-item"
    [ngClass]="{'scrollable-menu-item': item.isExtension && item.expanded && pinnedCameras.length > 0}">
    <!-- My Cloud item -->
    @if (!item.isExtension) {
    <div class="content"
      [class.selected]="item.selected"
      [class]="item.class"
      [attr.title]="item.text"
      [attr.aria-label]="item.text"
      [attr.aria-current]="item.selected ? 'page' : false"
      role="menuitem"
      tabindex="0"
      (appAccessibleClick)="handleSelectItem(item)">
      <span class="text">{{item.text}}</span>
    </div>
    }

    <!-- Extension item with cameras -->
    @if (item.isExtension) {
    <div class="content"
      [class.selected]="item.selected"
      [class]="item.class"
      [attr.title]="item.text"
      [attr.aria-label]="item.text"
      [attr.aria-current]="item.selected ? 'page' : false"
      [attr.aria-expanded]="item.expanded"
      role="menuitem"
      tabindex="0"
      (appAccessibleClick)="toggleExtension(item)">

      @if (cameras.length > 0 || pinnedCameras.length > 0) {
      <i class="chevron"
        [class.expanded]="item.expanded"></i>
      }

      <span class="text">{{item.text}}</span>
    </div>
    }

    <!-- Camera items -->
    @if (item.expanded) {
    <div class="camera-container">
      <div class="camera-list">
        @if (!isCamerasFullyLoaded) {
        <div class="camera-item loading">
          <div class="spinner-container">
            <app-vi-spinner [size]="'tiny'"></app-vi-spinner>
          </div>
          <span class="text">{{resources.Loading}}</span>
        </div>
        } @else {
        <ng-container>
          <!-- Pinned cameras -->
          <div *ngFor="let camera of pinnedCameras"
            class="camera-item"
            [ngClass]="{'disabled': camera.status !== CameraStatus.Online, 'selected': shouldSelectCamera && camera.id === selectedCamera?.id}"
            [attr.title]="camera.name"
            [attr.aria-label]="camera.name"
            [attr.aria-current]="shouldSelectCamera && camera.id === selectedCamera?.id ? 'page' : false"
            role="menuitem"
            tabindex="0"
            (appAccessibleClick)="handleCameraSelect(camera)">
            <span class="text">{{camera.name}}</span>
          </div>

          <!-- Hidden cameras count -->
          @if (item.hiddenCamerasCount > 0) {
          <div class="camera-item hidden"
            [attr.aria-label]="item.hiddenCamerasCount + ' ' + resources.Hidden + ' - ' + resources.ViewAllCameras"
            role="menuitem"
            tabindex="0"
            (appAccessibleClick)="showHiddenCameras(item)">
            <span class="text hidden">{{item.hiddenCamerasCount}} {{resources.Hidden}}</span>
            <span class="text link">{{resources.ViewAllCameras}}</span>
          </div>
          }
        </ng-container>
        }
      </div>
    </div>
    }
  </div>
</div>
